<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">IMTO Partners</h3>
          <p class="page-head__sub">Manage IMTO partner accounts and balances.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-building-o"></i> {{ agents?.length }} partners
          </span>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="content-body">
        <!-- Revenue, Hit Rate & Deals -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header card-toolbar">
                <h4 class="card-toolbar__title">
                  <i class="fa fa-building-o"></i> IMTO Partners
                  <span class="count-pill">{{ agents?.length }}</span>
                </h4>
                <div class="card-toolbar__actions">
                  <app-agent-filter (closeFilter)="onCloseFilter($event)" (filteredAgents)="getFilteredAgents($event)"
                  (onFormReset)="getAll()"></app-agent-filter>
                  <app-agent-modal (newAgents)="getAddedAgent($event)"></app-agent-modal>
                </div>
              </div>
              <div class="card-content">
                <div class="hover table-responsive">
                  @if (agents?.length > 0) {
                    <table class="table table-de mb-0">
                      <thead>
                        <tr>
                          <!-- <th><input type="checkbox" aria-label="Select all partners" /></th> -->
                          <th (click)="sortOrders('name')" tabindex="0" (keydown.enter)="sortOrders('name')"
                            (keydown.space)="sortOrders('name')">
                            IMTO Partner
                            @if (sortType === 'name' && !sortReverse) {
                              <i class="icons icon-sort"></i>
                            }
                            @if (sortType === 'name' && sortReverse) {
                              <i class="icons icon-rsort"></i>
                            }
                          </th>
                          <th (click)="sortOrders('balance')" tabindex="0" (keydown.enter)="sortOrders('balance')"
                            (keydown.space)="sortOrders('balance')">
                            Balance
                            @if (sortType === 'balance' && !sortReverse) {
                              <i class="icons icon-sort"></i>
                            }
                            @if (sortType === 'balance' && sortReverse) {
                              <i class="icons icon-rsort"></i>
                            }
                          </th>
                          <th (click)="sortOrders('date')" tabindex="0" (keydown.enter)="sortOrders('date')"
                            (keydown.space)="sortOrders('date')">
                            Date Added
                            @if (sortType === 'date' && !sortReverse) {
                              <i class="icons icon-sort"></i>
                            }
                            @if (sortType === 'date' && sortReverse) {
                              <i class="icons icon-rsort"></i>
                            }
                          </th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (agent of agents | paginate : config; track agent) {
                          <tr class="pull-up">
                            <!-- <td><input type="checkbox" [attr.aria-label]="'Select ' + (agent?.name || 'partner')" /></td> -->
                            <td>
                              <a [routerLink]="['/agent', $safeNavigationMigration(agent?.slug)]">{{
                                agent.name
                              }}</a>
                            </td>
                            <td>NGN {{ $safeNavigationMigration(agent?.balance) | number }}</td>
                            <td>{{ $safeNavigationMigration(agent?.created_at) | date }}</td>
                            <td>
                              <form>
                                <div class="form-group mt-1">
                                  <ui-switch [(ngModel)]="agent.status" (change)="onClick($event, agent.id)"
                                    [name]="'status_' + agent.id">
                                  </ui-switch>
                                </div>
                              </form>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (agents?.length > 10) {
                    <div style="text-align: center; width: 100%">
                      <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
                    </div>
                  }
                  @if (agents?.length === 0) {
                    <div class="empty-state">
                      {{ emptyAgentMessage }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-bottombar></app-bottombar>